import { UserPermission } from "~/common/utils";
import {
  hasConsultationAccess,
  hasGeneralAccess,
} from "~/common/utils/checkUserPermissions";
import { ROUTES } from "../../router";

export const getHomeRouteByPermissions = (permissions: UserPermission[]) => {
  let homeRoute: string = ROUTES.home;
  if (hasConsultationAccess(permissions) && !hasGeneralAccess(permissions)) {
    homeRoute = ROUTES.consultationRequests;
  }
  return homeRoute;
};
